export default __webpack_public_path__ + "static/blind-angels_trailer-b882aa5b7d039e16b48c024e23764bc0.mp4";